import * as actions from "./rooms.actions";
import * as types from "./rooms.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { RoomReducerType } from "./types";

export type RoomActions = ActionType<typeof actions>;

export const initialState: RoomReducerType = {
  error: null,
  rooms: [],
  isLoading: false,
  createdRoom: null,
  selectedRoom: null,
  meta: {
    total: 0,
    per_page: 0,
    last_page: 0,
    current_page: 0,
  }
};

export const RoomReducer = createReducer<
  RoomReducerType,
  RoomActions
>(initialState)
  .handleAction(actions.getRoomAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.getRoomAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    rooms: action.payload.data,
    meta: action.payload.meta
  }))
  .handleAction(actions.getRoomAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.selectRoomAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    createdRoom: null,
    selectedRoom: null,
    redirectQueue: ''
  }))
  .handleAction(actions.selectRoomAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    selectedRoom: action.payload.data,
  }))
  .handleAction(actions.selectRoomAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.updateRoomAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.updateRoomAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdRoom: action.payload.data,
  }))
  .handleAction(actions.updateRoomAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.createRoomAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.createRoomAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdRoom: action.payload.data
  }))
  .handleAction(actions.createRoomAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(types.SET_ERROR as any, (state, action) => ({
    ...state,
    error: action.payload.value
  }))
  .handleAction(types.RESET_STATE as any, (state, action) => ({
    ...state,
    error: null,
    createdRoom: null,
    selectedRoom: null
  }))
